import React from "react";
import styled from "@emotion/styled";
import { Swiper } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";

// Utils
import mediaQuery from "../../common/utils/mediaQuery";
import { Colors } from "../../common/utils/constants";

// Mui
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";

// Images
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const Container = styled(Box, {
    shouldForwardProp: (prop) => prop !== "topPagination",
})`
    .swiper {
        position: relative;
        margin: 0 -15px; /* for shadows */
        ${(props) =>
            props.topPagination
                ? `padding-top: 24px;`
                : "padding-bottom: 65px;"}
        //width: 100%; // Removed for mobile view
        max-width: 100vw;

        .loader-slide {
            display: none;

            &.sm {
                display: initial;
            }

            &.md {
                ${mediaQuery.tablet`
                display: initial;
                `}
            }

            &.lg {
                ${mediaQuery.desktop`
                display: initial;
                `}
            }

            &.xl {
                ${mediaQuery.large`
                display: initial;
                `}
            }
        }

        .swiper-pagination {
            width: auto !important;
            ${(props) =>
                props.topPagination
                    ? `height: 15px; top: 0; left: 60px`
                    : `bottom: 10px`};
            .swiper-pagination-bullet {
                width: 15px;
                height: 15px;
                background: ${Colors.primary};
            }
        }
    }

    .nav {
        position: absolute;
        z-index: 999;
        width: 75px;
        height: 75px;
        top: 50%;

        &.prev {
            left: 0;
        }

        &.next {
            right: 0;
        }

        &.swiper-button-disabled {
            display: none;
        }
    }
`;

const SwiperContainer = ({
    uniqueKey,
    children,
    breakpoints = {
        0: {
            slidesPerView: 1,
        },
        600: {
            slidesPerView: 2,
        },
        900: {
            slidesPerView: 2,
        },
        1200: {
            slidesPerView: 3,
        },
        1536: {
            slidesPerView: 4,
        },
    },
    spaceBetween = 0,
    pagination = {
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 4,
    },
    autoplay = false,
    accordion = false,
    navigation = true,
    loop = false,
    sx,
    topPagination = false,
}) => {
    return (
        <Container sx={sx} topPagination={topPagination}>
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={spaceBetween}
                breakpoints={breakpoints}
                navigation={
                    navigation && {
                        nextEl: uniqueKey ? `.n-${uniqueKey}` : ".next",
                        prevEl: uniqueKey ? `.p-${uniqueKey}` : ".prev",
                    }
                }
                pagination={pagination}
                className={uniqueKey}
                autoplay={autoplay}
                loop={loop}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => swiperRef.current = swiper}
            >
                {children}
            </Swiper>
            {navigation && (
                <>
                    <IconButton
                        className={`nav prev ${uniqueKey && `p-${uniqueKey}`} ${
                            accordion && "accordion"
                        }`}
                    >
                        <ChevronLeftIcon
                            sx={{ fontSize: 60 }}
                            color="primary"
                        />
                    </IconButton>
                    <IconButton
                        className={`nav next ${uniqueKey && `n-${uniqueKey}`} ${
                            accordion && "accordion"
                        }`}
                    >
                        <ChevronRightIcon
                            sx={{ fontSize: 60 }}
                            color="primary"
                        />
                    </IconButton>
                </>
            )}
        </Container>
    );
};

export default SwiperContainer;
